import React, { useEffect, useState } from "react";
import { PieChart } from "@mui/x-charts/PieChart";
import { Typography } from "@mui/material";
import { appSelector } from "../../redux/selector";
import { useSelector } from "react-redux";
import moment from "moment";
import { myCandidatesSelector } from "../redux/selector";

const ProfileStrengthChart = () => {
  const { candidateDetails } = useSelector(myCandidatesSelector);
  const [formData, setFormData] = useState([]);

  let filledCount = 0;
  let emptyCount = 0;
  let totalCount = 0;

  useEffect(() => {
    const fetch = async () => {
      const newFormData = await {
        firstName: candidateDetails?.first_name
          ? candidateDetails?.first_name
          : null,
        lastName: candidateDetails?.last_name
          ? candidateDetails?.last_name
          : null,
        email: candidateDetails?.email ? candidateDetails?.email : null,
        contactNumber:
          candidateDetails?.contact_no !== undefined &&
          candidateDetails?.contact_no !== null &&
          candidateDetails?.contact_no !== "undefined"
            ? candidateDetails?.contact_no
            : null,
        dob:
          candidateDetails?.date_of_birth !== undefined &&
          candidateDetails?.date_of_birth !== null &&
          candidateDetails?.date_of_birth !== "undefined" &&
          candidateDetails?.date_of_birth !== "0000-00-00 00:00:00"
            ? candidateDetails?.date_of_birth
            : null,
        gender: candidateDetails?.gender ? candidateDetails?.gender : null,
        experience: candidateDetails?.work_experience
          ? candidateDetails?.work_experience
          : null,
        educationLevels: null,
        jobTitle:
          candidateDetails?.role !== undefined &&
          candidateDetails?.role !== null &&
          candidateDetails?.role !== "undefined" &&
          candidateDetails?.role !== ""
            ? candidateDetails?.role
            : null,
        jobType:
          candidateDetails?.jobtype !== undefined &&
          candidateDetails?.jobtype !== null &&
          candidateDetails?.jobtype !== "undefined" &&
          candidateDetails?.jobtype !== ""
            ? candidateDetails?.jobtype
            : null,
        jobTypeID:
          candidateDetails?.jobtype_id !== undefined &&
          candidateDetails?.jobtype_id !== null &&
          candidateDetails?.jobtype_id !== "undefined" &&
          candidateDetails?.jobtype_id !== ""
            ? candidateDetails?.jobtype_id
            : null,
        USWorkAuthorization: candidateDetails?.work_authorization
          ? candidateDetails?.work_authorization
          : null,
        visaValidityUntill:
          candidateDetails?.visa_validity_date !== undefined &&
          candidateDetails?.visa_validity_date !== null &&
          candidateDetails?.visa_validity_date !== "Invalid date"
            ? moment(candidateDetails?.visa_validity_date).format("MM/YYYY")
            : null,
        willingToRelocate: candidateDetails?.willing_to_relocate
          ? candidateDetails?.willing_to_relocate
          : null,
        currentlyOnProject: candidateDetails?.currently_on_project
          ? candidateDetails?.currently_on_project
          : null,
        interviewTimeSlots: candidateDetails?.interview_time_slots
          ? candidateDetails?.interview_time_slots
          : null,
        availabilityForProject: candidateDetails?.availability_for_project
          ? candidateDetails?.availability_for_project
          : null,
        ssnLast4Digits: candidateDetails?.ssn
          ? parseInt(candidateDetails?.ssn)
          : null,
        certifications: candidateDetails?.certifications
          ? candidateDetails?.certifications
          : null,
        videoInterviewAvailability:
          candidateDetails?.video_interview_availability
            ? candidateDetails?.video_interview_availability
            : null,
        rate: candidateDetails?.desired_salary
          ? candidateDetails?.desired_salary
          : null,
        country:
          candidateDetails?.country_id !== undefined &&
          candidateDetails?.country_id !== null &&
          candidateDetails?.country_id !== "undefined" &&
          candidateDetails?.country_id !== 0
            ? candidateDetails.country_id
            : null,
        state:
          candidateDetails?.state_id !== undefined &&
          candidateDetails?.state_id !== null &&
          candidateDetails?.state_id !== "undefined" &&
          candidateDetails?.state_id !== 0
            ? candidateDetails.state_id
            : null,
        city:
          candidateDetails?.city_id !== undefined &&
          candidateDetails?.city_id !== null &&
          candidateDetails?.city_id !== "undefined" &&
          candidateDetails?.city_id !== 0
            ? candidateDetails.city_id
            : null,
        skills:
          candidateDetails?.related_titles !== ""
            ? candidateDetails?.related_titles
            : null,
        linkedIn: candidateDetails?.linkedin_url
          ? candidateDetails?.linkedin_url
          : null,
      };
      await setFormData([newFormData]);
    };
    fetch();
  }, [candidateDetails]);

  formData?.forEach((form) => {
    // Iterate over each key in the form object
    form &&
      Object.values(form)?.forEach((value) => {
        // Increment total count
        totalCount++;

        // Check if the value is null, undefined, or an empty string
        if (value === null || value === undefined || value === "") {
          emptyCount++;
        } else {
          filledCount++;
        }
      });
  });

  const totalPercentage = (filledCount / totalCount) * 100;
  // const totalPercentage = 55;

  const getColor = (percentage) => {
    if (percentage >= 80) return "#4CAF50";
    if (percentage >= 60) return "#FFC107";
    return "#FF5722";
  };

  return (
    <div
      style={{
        backgroundColor: "#fff",
        borderRadius: "6px",
        padding: "10px",
        position: "relative",
      }}
    >
      <Typography variant="h6" gutterBottom>
        Candidate Profile Strength
      </Typography>
      <Typography variant="body1" gutterBottom>
        Data Filled: {filledCount}
      </Typography>
      <Typography variant="body1" gutterBottom>
        Data Empty: {emptyCount}
      </Typography>
      <PieChart
        series={[
          {
            data: [
              {
                name: "Completed",
                value: totalPercentage,
                color: getColor(totalPercentage),
              },
              {
                name: "Remaining",
                value: 100 - totalPercentage,
                color: "#ccc", // Gray for remaining
              },
            ],
            innerRadius: 60,
            outerRadius: 102,
            paddingAngle: 6,
            cornerRadius: 6,
            startAngle: -160,
            endAngle: 160,
            cx: 150,
            cy: 150,
          },
        ]}
      />
      <div
        style={{
          position: "absolute",
          top: "56%",
          left: "45%",
          transform: "translate(-50%, -50%)",
          textAlign: "center",
        }}
      >
        <Typography variant="h6" sx={{ fontWeight: 800 }}>
          {totalPercentage.toFixed(2)}%
        </Typography>
      </div>
    </div>
  );
};

export default ProfileStrengthChart;

// import React from "react";
// import { PieChart } from "@mui/x-charts/PieChart";
// import { Typography } from "@mui/material";

// const ProfileStrengthChart = () => {
//   const formData = [
//     {
//       firstName: "srinivas",
//       lastName: "meesala",
//       email: "srinivas@gmail.com",
//       contactNumber: "5757588",
//       dob: null,
//       gender: "male",
//       experience: "4",
//       educationLevels: "masters",
//       languages: "english, telugu",
//       jobTitle: "react developer",
//       jobType: "full time",
//       currentSalary: "",
//       expectedSalary: "",
//     },
//     {
//       USWorkAuthorization: "GC",
//       visaValidityUntill: "23",
//       willingToRelocate: "23",
//       currentlyOnProject: "yes",
//       interviewTimeSlots: "",
//       availabilityForProject: "",
//     },
//     {
//       country: "US",
//       state: "",
//       city: "",
//     },
//     {
//       skills: ["JavaScript", "React", "Node.js"],
//       newSkill: "",
//     },

//     {
//       relatedTitles: [
//         "Software Developer",
//         "React Developer",
//         "Node.js Developer",
//       ],
//       newRelatedTitles: undefined,
//     },

//     {
//       linkedIn: "dfdgv",
//       skype: "dgdgb",
//     },
//   ];

//   let filledCount = 0;
//   let emptyCount = 0;

//   // Iterate over each object in formData
//   formData.forEach((form) => {
//     // Iterate over each key in the form object
//     Object.keys(form).forEach((key) => {
//       const value = form[key];
//       // Check if the value is null, undefined, or an empty string
//       if (value === null || value === undefined || value === "") {
//         emptyCount++;
//       } else {
//         filledCount++;
//       }
//     });
//   });

//   const totalFields = formData.reduce(
//     (total, form) => total + Object.values(form).filter(Boolean).length,
//     0
//   );
//   const totalPercentage = (totalFields / (formData.length * Object.keys(formData[0]).length)) * 100;

//   const getColor = (percentage) => {
//     if (percentage >= 80) return "#4CAF50"; // Green
//     if (percentage >= 60) return "#FFC107"; // Orange
//     return "#FF5722"; // Red
//   };

//   return (
//     <div
//       style={{
//         backgroundColor: "#fff",
//         borderRadius: "6px",
//         padding: "10px",
//         position: "relative",
//       }}
//     >
//       <Typography variant="h6" gutterBottom>
//         Profile Strength
//       </Typography>
//       <PieChart
//         series={[
//           {
//             data: [
//               {
//                 name: "Completed",
//                 value: totalPercentage,
//                 color: getColor(totalPercentage),
//               },
//               {
//                 name: "Remaining",
//                 value: 100 - totalPercentage,
//                 color: "#ccc", // Gray for remaining
//               },
//             ],
//             innerRadius: 60,
//             outerRadius: 102,
//             paddingAngle: 6,
//             cornerRadius: 6,
//             startAngle: -160,
//             endAngle: 160,
//             cx: 150,
//             cy: 150,
//           },
//         ]}
//       />
//       <div
//         style={{
//           position: "absolute",
//           top: "50%",
//           left: "46%",
//           transform: "translate(-50%, -50%)",
//           textAlign: "center",
//         }}
//       >
//         <Typography variant="h6" sx={{ fontWeight: 800 }}>
//           {totalPercentage.toFixed(2)}%
//         </Typography>
//       </div>
//     </div>
//   );
// };

// export default ProfileStrengthChart;

// import React from 'react';
// import { PieChart } from '@mui/x-charts/PieChart';
// import { Typography } from '@mui/material';

// const ProfileStrengthChart = ({ strength }) => {
//   const data = [
//     { name: 'Data1', value: 20, color: '#FF5733' },
//     { name: 'Data2', value: 30, color: '#FFC300' },
//     { name: 'Data3', value: 15, color: '#C70039' },
//     { name: 'Data4', value: 10, color: '#900C3F' },
//     { name: 'Data5', value: 5, color: '#581845' },
//     { name: 'Data6', value: 20, color: '#1A5276' },
//   ];

//   // Calculate total percentage
//   const totalPercentage = data.reduce((total, item) => total + item.value, 0);

//   return (
//     <div style={{ backgroundColor: '#fff', borderRadius: '6px', padding: '10px', position: 'relative' }}>
//       <Typography variant="h6" gutterBottom>
//         Profile Strength
//       </Typography>
//       <PieChart
//         series={[
//           {
//             data,
//             innerRadius: 60,
//             outerRadius: 102,
//             paddingAngle: 6,
//             cornerRadius: 6,
//             startAngle: -160,
//             endAngle: 160,
//             cx: 150,
//             cy: 150,
//           },
//         ]}
//       />
//       <div style={{ position: 'absolute', top: '50%', left: '46%', transform: 'translate(-50%, -50%)', textAlign: 'center' }}>
//         <Typography variant="h6" sx={{fontWeight:800}}>{totalPercentage}%</Typography>
//       </div>
//     </div>
//   );
// };

// export default ProfileStrengthChart;

// // ProfileStrengthChart.js
// import React from 'react';
// import { PieChart } from '@mui/x-charts/PieChart';
// import { Typography } from '@mui/material';

// const ProfileStrengthChart = ({ strength }) => {
//   const data = [
//     { name: 'Data1', value: 20, color: '#FF5733' },
//     { name: 'Data2', value: 30, color: '#FFC300' },
//     { name: 'Data3', value: 15, color: '#C70039' },
//     { name: 'Data4', value: 10, color: '#900C3F' },
//     { name: 'Data5', value: 5, color: '#581845' },
//     { name: 'Data6', value: 20, color: '#1A5276' },
//   ];

//   return (
//     <div style={{backgroundColor:'#fff', borderRadius:'6px', padding:'10px'}}>
//       <Typography variant="h6" gutterBottom>
//         Profile Strength
//       </Typography>
//       <PieChart
//         series={[
//           {
//             data,
//             innerRadius: 60,
//             outerRadius: 102,
//             paddingAngle: 6,
//             cornerRadius: 6,
//             startAngle: -160,
//             endAngle: 160,
//             cx: 150,
//             cy: 150,
//           },
//         ]}
//       />
//     </div>
//   );
// };

// export default ProfileStrengthChart;

// import React from 'react';
// import { PieChart, Pie, Cell, ResponsiveContainer, Legend } from 'recharts';
// import { Typography } from '@mui/material';

// const ProfileStrengthChart = ({ strength }) => {
//   const data = [
//     { name: 'Profile Strength', value: 70 },
//     { name: 'Remaining', value: 100 - 70 },
//   ];

//   const COLORS = ['#0088FE', '#FFBB28'];

//   return (
//     <div>
//       <Typography variant="h6" gutterBottom>
//         Profile Strength
//       </Typography>
//       <ResponsiveContainer width="100%" height={300}>
//         <PieChart>
//           <Pie
//             data={data}
//             dataKey="value"
//             nameKey="name"
//             cx="50%"
//             cy="50%"
//             outerRadius={80}
//             fill="#8884d8"
//             label
//           >
//             {data.map((entry, index) => (
//               <Cell key={`cell-${index}`} fill={COLORS[index % COLORS.length]} />
//             ))}
//           </Pie>
//           <Legend />
//         </PieChart>
//       </ResponsiveContainer>
//     </div>
//   );
// };

// export default ProfileStrengthChart;
